import { useContext, useEffect, useRef, useState } from "react";
import Dimmer from "../schedule/schedule_equipments/Dimmer";
import Remote from "../schedule/schedule_equipments/Remote";
import FanCoil from "../schedule/schedule_equipments/FanCoil";
// import ScenarioKey from "../scenario/scenario_equipments/ScenarioKey";
import RGB from "../schedule/schedule_equipments/RGB";
import Thermostat from "../schedule/schedule_equipments/Thermostat";
import Motor from "../schedule/schedule_equipments/Motor";
import WirelessKey from "../schedule/schedule_equipments/WirelessKey";
import { Context } from "../../context/Context";
import Television from "../schedule/schedule_equipments/Television";
import Key from "../schedule/schedule_equipments/Key";
import Humidity from "../schedule/schedule_equipments/Humidity";
import Input from "../schedule/schedule_equipments/Input";
import InputStatus from "../schedule/schedule_equipments/InputStatus";
import DataLogger from "../schedule/schedule_equipments/DataLogger";
const SelectScheduleOutputEquipmentModal = ({
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  setSelectOutputModal,
  data,
  setData,
}) => {
  const { scheduleEquipmentType, scheduleEquipmentId } = useContext(Context);

  const modalName = useRef(null);

  useEffect(() => {
    setSelectOutputModal(modalName);
  }, []);

  const renderEquipment = () => {
    if (scheduleEquipmentType == 100) {
      // Television
      return (
        <Television
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 3) {
      // Remote
      return (
        <Remote
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 4) {
      // Dimmer
      return (
        <Dimmer
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 501) {
      // Fan Coil
      return (
        <FanCoil
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 1) {
      // Scenario Key
      return (
        <Key
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 9997) {
      // Camera
      // return <FanCoil />
    } else if (scheduleEquipmentType == 9998) {
      // Input
      return (
        <Input
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 9) {
      // RGB
      return (
        <RGB
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 1) {
      // Key
      // return (
      //   <Key
      //     equipment_id={scheduleEquipmentId}
      //     closeSelectEquipmentRef={closeSelectEquipmentRef}
      //     closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
      //   />
      // );
    } else if (scheduleEquipmentType == 5) {
      // Thermostat
      return (
        <Thermostat
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 502) {
      // Motor
      return (
        <Motor
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 99) {
      // Wireless Key
      return (
        <WirelessKey
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 503) {
      // Humidity
      return (
        <Humidity
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 9999) {
      // Humidity
      return (
        <InputStatus
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    } else if (scheduleEquipmentType == 600) {
      // Humidity
      return (
        <DataLogger
          equipment_id={scheduleEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          data={data}
          setData={setData}
        />
      );
    }
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="selectOutputModal"
      tabIndex="-1"
      aria-labelledby="selectOutputLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title" id="selectOutputLable">
              انتخاب خروجی
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeSelectOutputEquipmentRef}
            ></button>
          </div>
          <div className="modal-body">{renderEquipment()}</div>
          {/* <div className="modal-footer"></div> */}
        </div>
      </div>
    </div>
  );
};

export default SelectScheduleOutputEquipmentModal;
